import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useParams, useLocation } from "react-router-dom";

function ViewIntegration({ chimeraserv, user }) {
  const { id } = useParams();
  const location = useLocation();
  const [integration, setIntegration] = useState(location.state?.data || null);
  const [loading, setLoading] = useState(!integration);
  const headers = {
    Authorization: user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  useEffect(() => {
    if (!integration && id) {
      const fetchIntegration = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            chimeraserv.urlGet + "/integration/view/" + id,
            { headers }
          );
          console.log("Integration data fetched:", response.data);
          setIntegration(response.data);
        } catch (error) {
          setIntegration(null);
        }
        setLoading(false);
      };
      fetchIntegration();
    }
  }, [id, chimeraserv.urlGet, user.data.usrKey, integration]);

  if (loading) {
    return (
      <div className="custForm">
        <Helmet>
          <title>View Integration | Chimera Solutions | Insights</title>
        </Helmet>
        <div className="viewTitle">View Integration</div>
        <div>Loading...</div>
      </div>
    );
  }

  if (!integration) {
    return (
      <div className="custForm">
        <Helmet>
          <title>View Integration | Chimera Solutions | Insights</title>
        </Helmet>
        <div className="viewTitle">View Integration</div>
        <div>No integration found.</div>
      </div>
    );
  }

  return (
    <div className="custForm">
      <Helmet>
        <title>View Integration | Chimera Solutions | Insights</title>
      </Helmet>
      <div className="viewTitle">Integration Details</div>
      <div className="form fullWidth">
        <div className="form-group">
          <label>Name:</label>
          <div>{integration.name}</div>
        </div>
        <div className="form-group">
          <label>Group Key:</label>
          <div>{integration.grpKey}</div>
        </div>
        <div className="form-group">
          <label>Brand Key:</label>
          <div>{integration.braKey}</div>
        </div>
        <div className="form-group">
          <label>Vendor ID:</label>
          <div>{integration.vendorID}</div>
        </div>
        <div className="form-group">
          <label>Vendor Name:</label>
          <div>{integration.vendorName}</div>
        </div>
        <div className="form-group">
          <label>Vendor Country:</label>
          <div>{integration.vendorCountry}</div>
        </div>
        <div className="form-group">
          <label>Outlets & Store Numbers:</label>
          <div>
            {integration.outlets && integration.outlets.length > 0 ? (
              <table className="table table-striped defaultTable">
                <thead>
                  <tr>
                    <th>Outlet Key</th>
                    <th>Store Number</th>
                  </tr>
                </thead>
                <tbody>
                  {integration.outlets.map((o, idx) => (
                    <tr key={idx}>
                      <td>{o.chaKey}</td>
                      <td>{o.storeNum}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <span>No outlets available.</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewIntegration;
